import { Component, OnInit, Input, ElementRef, ViewChild } from '@angular/core';
import { SubjectWiseSummary } from '../../models/subject-wise-summary';
import { SwiperConfigInterface, SwiperNavigationInterface, SwiperPaginationInterface } from 'ngx-swiper-wrapper';

@Component({
  selector: 'app-subject-wise-summary',
  templateUrl: './subject-wise-summary.component.html',
  styleUrls: ['./subject-wise-summary.component.scss']
})
export class SubjectWiseSummaryComponent implements OnInit {
  constructor() { }

  @Input() subjectWiseSummary: Array<SubjectWiseSummary>
  @Input() enableClick: Boolean
  @ViewChild('svg', { static: true }) el: ElementRef

  private navigation: SwiperNavigationInterface = {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }

  private pagination: SwiperPaginationInterface = {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  }

  config: SwiperConfigInterface = {
    slidesPerView: 4,
    navigation: this.navigation,
    pagination: this.pagination,
    breakpoints: {
      1500: {
        slidesPerView: 3,
      },
      1200: {
        slidesPerView: 2,
      },
      600: {
        slidesPerView: 1,
      },
    }
  };


  ngOnInit() {
  }

  setClass() {
    var withGraph = false;
    var withMark = false;
    this.subjectWiseSummary.forEach(o => {
      if (o.exam_wise_marks.length > 1 && o.subject_grade_string == null) {
        withGraph = true;
      }
      else if (o.exam_wise_marks.length == 1) {
        withMark = true;
      }
    });
    if (withGraph) {
      return "withGraph";
    }
    else if (withMark) {
      return "withMark";
    }
  }
}
